import React from 'react';
import { lazyComponents } from "@src/utilities/LazyComponent";

BlogArticlesListComponent.displayName = 'theme__blog-articles-list';
export function BlogArticlesListComponent({ ...props }) {
    const BlogArticlesList = lazyComponents['BlogArticlesList'];
    const { articles } = props.settings;

    return (
        <BlogArticlesList initialArticles={articles} settings={props.settings} />
    );
}

FeaturedBlogComponent.displayName = 'theme__blog-featured_blog';
export function FeaturedBlogComponent({ ...props }) {
    const FeaturedBlog = lazyComponents['FeaturedBlog'];
    return (
        <FeaturedBlog article={props.settings.article} settings={props.settings.section} />
    );
}

BlogArticleTileComponent.displayName = 'theme__block-article';
export function BlogArticleTileComponent({ ...props }) {
    const BlogArticleTile = lazyComponents['BlogArticleTile'];

    console.log("Article Settings:", props); // Debugging line
    // Extract article block settings for conditional rendering
    const articleSettings = props.settings.block_settings || {};
    const article = props.settings.article || props.settings.block_settings?.article;
    
    // Extract toggle settings from article.liquid block settings
    const showImage = articleSettings.show_image;
    const showTitle = articleSettings.show_title;
    const showExcerpt = articleSettings.show_excerpt;
    const showAuthor = articleSettings.show_author;
    const showPublishedDate = articleSettings.show_date;
    const showReadTime = articleSettings.show_read_time;
    const showTags = articleSettings.show_tags;
    const showReadMore = articleSettings.show_read_more;

    return (
        <BlogArticleTile
            settings={props.settings} 
            article={article}
            articleBlockSettings={articleSettings}
            showImage={showImage}
            showTitle={showTitle}
            showExcerpt={showExcerpt}
            showAuthor={showAuthor}
            showPublishedDate={showPublishedDate}
            showReadTime={showReadTime}
            showTags={showTags}
            showReadMore={showReadMore}
        />
    );
}

SocialShareComponent.displayName = '';
export function SocialShareComponent({ ...props }) {
    const SocialShare = lazyComponents['SocialShare'];
    return (
        <SocialShare props={props.settings} />
    );
}

BlogFiltersComponent.displayName = 'theme__blog-filters';
export function BlogFiltersComponent({ ...props }) {
    const BlogFilters = lazyComponents['BlogFilters'];
    return (
        <BlogFilters settings={props.settings} />
    );
}
